import { render, staticRenderFns } from "./GoogleRecaptcha.vue?vue&type=template&id=7f682ac8&"
import script from "./GoogleRecaptcha.vue?vue&type=script&lang=js&"
export * from "./GoogleRecaptcha.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports